import '../styles/Primitives.scss';

export default function TextField({ children, className = '', fullWidth, helperText, inputProps = {}, label, minRows, multiline = false, select = false, slotProps, ...props }) {
  void slotProps;
  const Control = select ? 'select' : multiline ? 'textarea' : 'input';
  return <label className={`ui-text-field ${fullWidth ? 'ui-text-field--full-width' : ''} ${className}`.trim()}>{label && <span className="ui-text-field__label">{label}</span>}<Control className="ui-text-field__control" rows={multiline ? minRows : undefined} {...inputProps} {...props}>{select ? children : undefined}</Control>{helperText && <span className="ui-text-field__helper">{helperText}</span>}</label>;
}
